import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'default-class-course-content-visibility',
    components: {

    },
})

export default class DefaultClassCourseContentVisibility extends Vue {

    // ------------------------------------------------------------------
    // Properties
    @Prop()
    private selectedConfig: any;

    private defaultText: any = '';

    // -------------------------------------------------------------------
    // Hooks
    private created() {
        const tenantSettings = this.selectedConfig.tenantConfig;
        if (tenantSettings && tenantSettings.value) {
            this.defaultText = tenantSettings.value;
        }
    }

    // ------------------------------------------------------------------
    // Actions

    private onChangeConfig() {
        this.$emit('onChangeConfig', this.defaultText);
    }
}
